import React, { Component, PropTypes } from 'react'
import { reduxForm } from 'redux-form'

import SetupformDetailsForm from './setupform-details-form'
import LoadingSpinner from 'components/loading-spinner'
import { getSetupformFields } from 'selectors/setupform'
import validate from 'utils/validate'
import FIELDS from './fields'

const FIELD_NAMES = FIELDS.map(field => field.name)

export class SetupformDetailsFormContainer extends Component {

  render() {
    if (this.props.loading) {
      return <LoadingSpinner />
    }

    return <SetupformDetailsForm {...this.props} />
  }

}

SetupformDetailsFormContainer.propTypes = {
  fields: PropTypes.object,
  loading: PropTypes.bool,
}

export const mapStateToProps = (state, ownProps) => {
  const initialValues = getSetupformFields(ownProps.setupformId, FIELD_NAMES)(state)

  return {
    initialValues,
    loading: initialValues === null,
  }
}

export default reduxForm({
  form: 'setupformDetails',
  fields: FIELD_NAMES,
  validate: validate(FIELDS),
}, mapStateToProps)(SetupformDetailsFormContainer)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-details-form/setupform-details-form-container.js
 **/